import { render, staticRenderFns } from "./QuestionsTabsComponent.vue?vue&type=template&id=1a0f8e4c&scoped=true"
import script from "./QuestionsTabsComponent.vue?vue&type=script&lang=js"
export * from "./QuestionsTabsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f8e4c",
  null
  
)

export default component.exports